import { useSyncExternalStore } from "react";
import { LINE_QUOTE_URL_MOBILE, LINE_QUOTE_URL_WEB } from "./constants";

const MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function useLineQuoteUrl() {
  return useSyncExternalStore(
    () => () => undefined,
    () => {
      if (typeof navigator === "undefined") return LINE_QUOTE_URL_MOBILE;
      const isMobile = MOBILE_USER_AGENT_REGEX.test(navigator.userAgent || "");
      return isMobile ? LINE_QUOTE_URL_MOBILE : LINE_QUOTE_URL_WEB;
    },
    () => LINE_QUOTE_URL_MOBILE
  );
}
